import React, { Component } from "react";
import { Row, Col, Button, Form, Modal } from "react-bootstrap";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import { RadioGroup, Radio } from "react-radio-group";
import Switch from "react-switch";
import "react-toastify/dist/ReactToastify.css";
// import "./TransInvoiceStatus.css";

class ItemDetailsEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: {
        value: {
          qntty: this.props.ItemDetailsdtList
            ? this.props.ItemDetailsdtList.qntty
            : null,
          avlble: this.props.ItemDetailsdtList
            ? this.props.ItemDetailsdtList.avlble
            : null
        }
      }
    };
    this.handleChange = this.handleChange.bind(this);
    this.onChange = this.onChange.bind(this);
    this.submit = this.submit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      value: {
        qntty: nextProps.ItemDetailsdtList && nextProps.ItemDetailsdtList.qntty,
        avlble:
          nextProps.ItemDetailsdtList && nextProps.ItemDetailsdtList.avlble,
        id: nextProps.ItemDetailsdtList && nextProps.ItemDetailsdtList.id
      }
    });
  }

  // handleChange(checked) {
  //   this.setState({ value: { ...this.state.value, avlble: checked } });
  // }
  handleChange(checked) {
    if (checked === true) {
      this.setState({ value: { ...this.state.value, avlble: checked } });
    } else {
      this.setState({
        value: { ...this.state.value, avlble: checked }
      });
    }
  }

  onChange = event => {
    let name = event.target.name;
    let value = event.target.value;
    if (name == "qntty") {
      this.setState({
        value: { ...this.state.value, qntty: value }
      });
      console.log("##########################", value);
    }
  };

  // submit = () => {
  //   const value = this.state.value;
  //   console.log("_____________ iconUrl: this.state.value.iconurl,", value);
  //   this.props.EditItemDetails(this.state.value);
  //   this.props.closeEditModel();
  //   this.props.resetPage();
  // };
  // submit() {

  //   const value = this.state.value;
  //   if (value.avlble) {
  //     if (value.qntty) {
  //       this.props.EditItemDetails(this.state.value);
  //       this.props.closeEditModel();
  //     }
  //   } else {
  //     this.props.EditItemDetails(this.state.value);
  //     this.props.closeEditModel();
  //   }
  // }
  render() {
    return (
      <div>
        <div className="modelboxdesigns">
          <Modal
            show={this.props.showItemDetailsEditModel}
            onHide={this.props.closeEditModel}
            animation={false}
            size="md"
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "#00000080" }}
          >
            <Modal.Header
              style={{
                fontSize: "35px",
                backgroundColor: "#1768B7",
                color: "white"
              }}
              closeButton
            >
              <Modal.Title>
                <span style={{ fontSize: "20px" }}>Edit Item Details</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Row>
                <Col lg={12}>
                  <Form>
                    <div style={{ maxWidth: 250, margin: "auto" }}>
                      <Form.Group controlId="avlble">
                        <Form.Label>Availability</Form.Label>
                        <div style={{ display: "flex" }}>
                          <label style={{ display: "flex", marginTop: "8px" }}>
                            <div style={{}}>{/* <span>Active</span> */}</div>
                            <div style={{ marginTop: "-5px" }}>
                              <Switch
                                onChange={this.handleChange}
                                onColor="#20a8d8"
                                checked={
                                  this.state.value.avlble
                                    ? this.state.value.avlble
                                    : false
                                }
                                // checked={this.state.value.avlble ? true : false}
                              />
                            </div>
                          </label>
                        </div>
                      </Form.Group>

                      {this.state.value.avlble ? (
                        <Form.Group controlId="qntty">
                          <Form.Label>Quantity</Form.Label>
                          <Form.Control
                            type="text"
                            // placeholder="Credit Limit"
                            autoComplete="off"
                            name="qntty"
                            onChange={this.onChange}
                            value={this.state.value.qntty || ""}
                          />
                        </Form.Group>
                      ) : null}
                    </div>
                  </Form>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: "#1768B7" }}>
              <Button type="submit" onClick={this.submit}>
                Submit
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

export default ItemDetailsEdit;
